import type { HTMLAttributeAnchorTarget } from "react";
import {
    ResolvedMegaMenuCtaButton,
    ResolvedSectionBody,
} from "resolvers/data/header/megaMenuResolver";
import type { ResolvedMegaMenuSectionLink } from "./megaMenuSectionLinksResolver";

export enum MegaMenuSectionEnum {
    Links = "links",
    Banners = "banners",
}

export type ResolvedMegaMenuSectionTitle = {
    text?: string;
    link?: string;
    target?: HTMLAttributeAnchorTarget;
};

export enum SectionWidths {
    "w1" = 1,
    "w2" = 2,
    "w3" = 3,
    "w4" = 4,
    "normal" = 1, //@todo rename to small
    "large" = 2,
}

export type SectionWidthTypes = keyof typeof SectionWidths;

export type ResolvedMegaMenuSection = {
    type?: MegaMenuSectionEnum;
    title?: ResolvedMegaMenuSectionTitle;
    links?: ResolvedMegaMenuSectionLink[];
    sections?: ResolvedMegaMenuSection[];
    highlighted?: boolean;
    body?: ResolvedSectionBody[];
    width: SectionWidthTypes;
    background: boolean;
    ctaButtons?: {
        position: string;
        body: ResolvedMegaMenuCtaButton[];
    };
};

// Mega menu section resolver to be implemented
